/* eslint-disable no-unused-vars */
import {createApp} from 'vue'
import gTagPlugin from "@/plugins/gTagPlugin.js";

import {createCustomerRouter} from './routes/index.js'
import PluginDialog from "@/utils/pluginDialog.js";
import {useSessionStore} from "@/utils/useSessionStore.js"
import {loadingDirective} from "@/utils/LoadingDirective.js";
import {languagePlugin, locale} from "@/i18n/useLanguage.js";
import {iconicPlugin} from '@/plugins/IconicPlugin.js'
import {GlobalComponentPlugin} from "@/plugins/GlobalComponentPlugin.js";
import VueTour from 'vue3-tour'
import '@/assets/css/tour.css'

import {createPinia} from 'pinia'
import App from './App.vue'
import "./assets/css/tailwindcss.css"
import './style.scss'
import ScreenHelper from "@/plugins/ScreenHelper.js";
import axios from "axios";
export function createCustomerApp(initialState = null){
  const app = createApp(App);
  app.directive('loading', loadingDirective)

  const pinia = createPinia()
  if (initialState && typeof initialState === 'object') {
    pinia.state.value = initialState;

    const language = initialState.session?.language;
    const currency = initialState.session?.currency;
    if (typeof window !== 'undefined' && (language || currency)) {
      try {
        if (language) {
          locale.value = language;
          window.localStorage.setItem('pinia/session/language', language);
        }
        if (currency) {
          window.localStorage.setItem('pinia/session/currency', currency);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
  app.use(pinia);
  useSessionStore(pinia);
  app.use(ScreenHelper);
  app.use(PluginDialog);
  app.use(iconicPlugin);
  app.use(languagePlugin);
  const router = createCustomerRouter();
  app.use(gTagPlugin, router);
  app.use(router)
  app.use(VueTour)
  app.use(GlobalComponentPlugin);

  return {app, router, pinia};
}
